import React from "react";
import { cn } from "@/components/utils";

function Skeleton({ className, ...props }) {
  return (
    <div
      className={cn("bg-muted animate-pulse rounded-xl", className)}
      {...props}
    />
  );
}

function SkeletonList({ count = 5 }) {
  return (
    <div className="flex h-full w-full flex-col gap-[4px] mask-b-from-50">
      {Array.from({ length: count }).map((_, index) => (
        <Skeleton
          key={index}
          className="border-edge h-[50px] w-full border border-slate-300"
        />
      ))}
    </div>
  );
}

function SkeletonDetailsView({ className }) {
  return (
    <div
      className={cn(
        className,
        "flex w-full animate-pulse flex-col gap-6 self-start mask-b-from-50",
      )}
    >
      <div className="panel-box">
        <Skeleton className="h-12 w-full" />
        <Skeleton className="h-[310px] w-full" />
      </div>
      <div className="panel-box">
        <Skeleton className="h-[200px] w-full" />
      </div>
    </div>
  );
}

export { Skeleton, SkeletonList, SkeletonDetailsView };
